import api from '@/apis/di/sysUserAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid quản lý người dùng
export const useManagerUserComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();
  // func call api lấy dữ liệu combo
  const onManagerUserComboboxLoadData = (payload, row, column, customData) => {
    payload.sort = 'full_name,email';
    let ors = [{ Field: 'account_manager', Operator: 'NULL' }];
    let extend = [{ Field: 'account_manager', Value: false, Ors: ors }];
    payload.filter = extendFilter(payload.filter, extend);

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, customData?.callBackFn);
  };

  // config columns combo
  const managerUserComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Tên người dùng',
        dataField: 'full_name',
        width: 160,
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
      },
      { title: 'Email', dataField: 'email', width: 160, filterOperator: proxy.$ms.constant.FilterOperator.Contains },
      {
        title: 'Số điện thoại',
        dataField: 'phone_number',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 270,
      },
    ],
    displayField: 'full_name',
    valueField: 'user_id',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onManagerUserComboboxLoadData,
  };

  // Sự kiện load combo trên grid
  return { managerUserComboConfig, onManagerUserComboboxLoadData }; // trả về thêm để dùng chung cho cả combo không thuộc grid
};
